import { Injectable, signal } from '@angular/core';
import { IClaimBeneficiaryInfo } from '@core/interfaces/claim.Interface';

@Injectable({
  providedIn: 'root',
})
export class BeneficiaryService {
  private readonly _selectedBeneficiary = signal<IClaimBeneficiaryInfo | undefined>(undefined);

  selectedBeneficiary = this._selectedBeneficiary.asReadonly();

  setSelectedBeneficiary(beneficiary: IClaimBeneficiaryInfo) {
    if(beneficiary.status == undefined) beneficiary.status = 'ENABLED';
    this._selectedBeneficiary.set(beneficiary);
  }
}
